module.exports = __webpack_public_path__ + "static/img/qrcode.c41306a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.png
// module id = jWhC
// module chunks = 1